<div class="flex items-center justify-center min-h-screen bg-pmdf-bg-subtle p-4">
  @if (errorMessage()) {
    <div class="flex flex-col items-center text-center gap-3 bg-pmdf-surface rounded-pmdf-card shadow-pmdf-card p-6 max-w-sm w-full">
      <mat-icon class="icon-2xl text-pmdf-danger">error_outline</mat-icon>
      <h1 class="text-lg font-semibold text-pmdf-text-primary">Não foi possível entrar</h1>
      <p class="text-sm text-pmdf-muted-70">{{ errorMessage() }}</p>
      <button
        mat-raised-button
        color="primary"
        class="w-full mt-2"
        (click)="retry()"
      >
        {{ retryLabel() }}
      </button>
    </div>
  } @else {
    <div class="text-center">
      <div class="mb-4">
        <svg class="animate-spin w-16 h-16 mx-auto text-pmdf-info" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
      <h1 class="text-2xl font-semibold text-pmdf-text-primary mb-2">Processando autenticação...</h1>
      <p class="text-pmdf-muted-70">Aguarde enquanto validamos suas credenciais.</p>
    </div>
  }
</div>
